import { createElement } from 'external/react'

import Home from './parent/HomeContainer'
import Package from './parent/PackageContainer'
import Users from './parent/UsersContainer'
import NewUser from './parent/NewUserContainer'
import UserPackage from './parent/UserPackageContainer'
import Payment from './parent/PaymentContainer'
import PaymentHistory from './parent/PaymentHistory'
import Profile from './parent/ProfileContainer'

import AdminHome from './admin/HomeContainer'
import AdminOffersContainer from './admin/OffersContainer'
import AdminOfferConfigurationContainer from './admin/OfferConfigurationContainer'
import ClientsContainer from './admin/ClientsContainer'
import ClientContainer from './admin/ClientContainer'

import AccountingHome from './accounting/HomeContainer'
import AccountingPayoutsContainer from './accounting/PayoutsContainer'
import AccountingPayoutContainer from './accounting/PayoutContainer'

const parentContainers = {
    Home,
    Package,
    Users,
    NewUser,
    UserPackage,
    Payment,
    PaymentHistory,
    Profile
}

type ParentContainerName = keyof typeof parentContainers

const adminContainers = {
    Home: AdminHome,
    Offers: AdminOffersContainer,
    OfferConfiguration: AdminOfferConfigurationContainer,
    Clients: ClientsContainer,
    Client: ClientContainer
}

type AdminContainerName = keyof typeof adminContainers

const accountingContainers = {
    Home: AccountingHome,
    Payouts: AccountingPayoutsContainer,
    Payout: AccountingPayoutContainer
}

type AccountingContainerName = keyof typeof accountingContainers

export function wrapParentContainer(containerName: ParentContainerName, Page: any) {
    return () => createElement(parentContainers[containerName], {}, createElement(Page))
}

export function wrapAdminContainer(containerName: AdminContainerName, Page: any) {
    return () => createElement(adminContainers[containerName], {}, createElement(Page))
}

export function wrapAccountingContainer(containerName: AccountingContainerName, Page: any) {
    return () => createElement(accountingContainers[containerName], {}, createElement(Page))
}